import React, {Component} from "react";
import {Modal, Form, Button} from "react-bootstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlay} from '@fortawesome/free-solid-svg-icons'
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import "./Audio.css";

export default class Audio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            play: false
        };
    }

    getMyAudio = () => {
        let src_m4a = null;
        let src_mp3 = null;
        let src_ogg = null;
        let src_wav = null;
        let src = null;
        let real_path = "";
        try {
            if (this.props.type === "file") {
                src = URL.createObjectURL(this.props.data[0]);
            }
            let path = this.props.data.match(/(.*)(?:\.([^.]+$))/)[1];
            let path_arr = path.split("/");

            //ファイル名に特殊文字が含まれている場合、pathでファイル名だけエンコードする
            let specialChar = /[&$@=;:+,?]/g; 
            if(specialChar.test(path_arr[path_arr.length-1])) {
                let encoded_file_name = `${encodeURIComponent(path_arr[path_arr.length-1])}`;
                path_arr.pop();
                path_arr.push(encoded_file_name);
                real_path = path_arr.join('/');
            }else{ 
                real_path = path;
            }

            src_ogg = `${real_path}.ogg`;
            src_m4a = `${real_path}.m4a`;
            src_mp3 = `${real_path}.mp3`;
            src_wav = `${real_path}.wav`;
        } catch (err) {}

        let return_element =[];
        if (this.props.plyr) {
            // Plyr-react 用の source 定義
            const sources = [];
            if (src_ogg) sources.push({ src: src_ogg, type: "audio/ogg" });
            if (src_m4a) sources.push({ src: src_m4a, type: "audio/mp4" });
            if (src_mp3) sources.push({ src: src_mp3, type: "audio/mp3" });
            if (src_wav) sources.push({ src: src_wav, type: "audio/wav" });
            if (src)     sources.push({ src: src,     type: "audio/mp4" });
            
            const plyrSource = { type: "audio", sources };
            const audioSpeed = this.props.langText.SelectOption.AudioSpeed.map(row => row.value);
            
            return_element.push(
                <div className="asc-audio" key="asc-audio-wrap">
                    <Plyr
                        id="asc-audio"
                        source={plyrSource}
                        options={{
                            controls: ['play','progress','current-time','duration','mute','volume','settings'],
                            settings: ['speed'],
                            i18n: { speed: this.props.langText.Body.PlaySpeed, normal: this.props.langText.Body.Normal },
                            speed: { selected: 1, options: audioSpeed },
                            storage: { enabled: false },
                            invertTime: false,
                            autoplay: true
                        }}
                        onPlay={e => {
                            if (this.props.onPlayHandle) {
                                this.props.onPlayHandle(e && e.target ? e.target : null);
                            }
                        }}
                    />
                </div>
            );
        } else {
            return_element.push(
                <audio
                    id = "asc-audio"
                    key = "asc-audio"
                    className = "asc-audio"
                    controls = {true}
                    controlsList = "nodownload"
                    autoPlay = {true}
                    onPlay = {e => {
                        if (this.props.onPlayHandle) {
                            this.props.onPlayHandle(document.getElementById('asc-audio'));
                        }
                    }}
                >
                    <source  src = {src_ogg} type="audio/ogg"></source>
                    <source  src = {src_m4a} type="audio/mp4"></source>
                    <source  src = {src_mp3} type="audio/mp3"></source>
                    <source  src = {src_wav} type="audio/wav"></source>
                    <source  src = {src} type="audio/mp4"></source>
                </audio>
        
            );
        }
        if (this.props.type === "file") {
            return_element.push(
                <label>{this.props.langText.Message.Format_Not_Support}</label>
            );
        }
        return return_element;
    }

    clickCheck(e) {
        e.preventDefault();
        return false;
    }

    render() {
        let {
            title = "",
            bsSize = "xsmall",
            type,
            data,
            onPlayHandle,
            ...props
        } = this.props;
        let audioElem = this.getMyAudio();
        let returnElem = [
            <Modal
                key = {0}
                className = "asc-audio-modal"
                show = {this.state.play}
                onHide = {e => this.setState({play: false})}
                onContextMenu = {e => this.clickCheck(e)}>
                <Form horizontal = {true}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {audioElem}
                    </Modal.Body>
                </Form>
            </Modal>,
            <Button
                key = {1}
                bsSize = {bsSize}
                onClick = {e => this.setState({play: true})}
                {...props}>
                <FontAwesomeIcon
                    icon = {faPlay}/>
            </Button>
        ];

        return returnElem;
    }
}
